module.exports = __webpack_public_path__ + "img/background-top-pink.a8d3d1f6.svg";